var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline"},[(!_vm.$slots.fixed)?[_vm._v(" { "+_vm._s(_vm.$slots.default[0])+"} ")]:[_vm._t("fixed"),(_vm.$slots.default)?_c('div',{staticClass:"timeline--scrollable"},[_vm._t("default")],2):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }